import { createContext, useContext, useReducer, useMemo } from 'react';
import { usersReducer, initialState } from './reducer';

const UsersContext = createContext();

export const UsersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(usersReducer, initialState);

    const value = useMemo(() => [state, dispatch], [state]);

    return <UsersContext.Provider value={value}>{children}</UsersContext.Provider>;
};

export const useUsersContext = () => {
    const context = useContext(UsersContext);
    if (!context) {
        throw new Error('useUsersContext must be used within a UsersProvider');
    }
    return context;
};
